<template>
  <div class="check-box">
    <div class="check-fail-wrp">
      <template v-for="(item, index) in statusConf">
        <div class="check-fail-box" v-if="checkStatus === item.status" :key="index">
          <van-image
            class="check-status-img"
            :width="transPxToRem(80)"
            :height="transPxToRem(80)"
            :src="item.statusImg"
          />
          <div class="check-status">{{ item.statusTitle }}</div>
          <div class="check-status-des">{{ item.statusDes }}</div>
          <van-button class="submit-button" type="primary" @click="handleBtnFun(item.btnTargetPath)" block>{{
            item.btnText
          }}</van-button>
        </div>
      </template>
    </div>
    <div class="check-content-title">
      <div class="pre-line"></div>
      <div class="title">审核内容</div>
      <div class="next-line"></div>
    </div>
    <div>
      <van-image
        v-for="(item, index) in groupImgs"
        :key="index"
        :width="transPxToRem(78)"
        :height="transPxToRem(78)"
        @click="handleImagePreview(index)"
        fit="contain"
        :src="item"
      />
    </div>
  </div>
</template>
<script setup>
import { computed, ref, onMounted } from 'vue'
import { BriskStatusEnum } from './brisk.data'
import { transPxToRem } from '@/utils'
import usePage from '@/hooks/usePage'
import { ImagePreview } from 'vant'
import groupPicCheckFailImg from '@/assets/img/group-pic-check-fail.png'
import groupPicCheckIngImg from '@/assets/img/group-pic-check-ing.png'
import groupPicCheckSuccessImg from '@/assets/img/group-pic-check-success.png'
import { groupScreenshotDetailApi } from '@/api/brisk'

const { navigateTo, navigateBack } = usePage()
const checkStatus = ref(BriskStatusEnum.CHECK_ING)
const checkRemark = ref('')
const successBrisk = ref(0)
const groupImgs = ref([])

const statusConf = computed(() => [
  {
    statusTitle: '审核失败！',
    statusImg: groupPicCheckFailImg,
    statusDes: `备注：${checkRemark.value}`,
    status: BriskStatusEnum.CHECK_FAIL,
    btnText: '重新上传',
    btnTargetPath: '/brisk/briskUploadGroupPic'
  },
  {
    statusTitle: '审核成功！',
    statusImg: groupPicCheckSuccessImg,
    statusDes: `恭喜您获得 ${successBrisk.value}活跃值`,
    status: BriskStatusEnum.CHECK_SUCCESS,
    btnText: '知道了',
    btnTargetPath: ''
  },
  {
    statusTitle: '审核中！',
    statusImg: groupPicCheckIngImg,
    statusDes: `审核通过后，可获得${successBrisk.value}活跃值`,
    status: BriskStatusEnum.CHECK_ING,
    btnText: '知道了',
    btnTargetPath: ''
  }
])

const handleBtnFun = path => {
  path ? navigateTo(path) : navigateBack()
}

const getGroupScreenshotDetail = async () => {
  const resData = await groupScreenshotDetailApi()
  if (resData) {
    const { remark, brisk, content, status } = resData
    checkRemark.value = remark
    checkStatus.value = status
    successBrisk.value = brisk
    groupImgs.value = content
  }
}

const handleImagePreview = i => {
  ImagePreview({
    images: groupImgs.value,
    startPosition: i
  })
}

onMounted(getGroupScreenshotDetail)
</script>
<style lang="less" scoped>
.check-box {
  height: 100%;
  background-color: #fff;
  padding: 0 16px;
}
.check-fail-wrp {
  padding: 0 35px;
  .check-fail-box {
    text-align: center;
    margin: auto;
    padding: 100px 0;
    .check-status {
      font-weight: 500;
      line-height: 28px;
      font-size: 20px;
      margin-top: 20px;
      margin-bottom: 8px;
    }
    .check-status-des {
      font-size: 14px;
      color: #999;
    }
  }
  .submit-button {
    margin-top: 40px;
  }
}
.check-content-title {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  margin-bottom: 20px;
  .title {
    margin: 0 3px;
    font-weight: 400;
    color: #222222;
  }
  .pre-line,
  .next-line {
    width: 40px;
    height: 1px;
    background: linear-gradient(90deg, #999999 0%, rgba(216, 216, 216, 0) 100%);
  }
  .pre-line {
    background: linear-gradient(270deg, #999999 0%, rgba(216, 216, 216, 0) 100%);
  }
}
</style>
